export default __webpack_public_path__ + "images/ebc8fa4e2b1585a6ebe80ba0add1b86b-san_diego_desktop.webp";